<section class="page_groupdetail">
  <div class="board">
    <CardInfo @setCalibration="setCalibration" :btn2="t('__d4e_m8t.__downloadCsv')"
      :btn1="t('__d4e_m8t.__setCalibration')" :dataInfo="state.rawData" @setUnbind="geCVS" class="cardInfo">
      <template #card="{ data}">
        <ContentGroup :date="state.rawData.created_at" :titleType="t('__common.__group')" :data="state.rawData"
          @menuSetting="littleMenuSetting">
        </ContentGroup>
      </template>
    </CardInfo>
    <Tab class="tab" :tabText="tabText" :defaultActiveIndex="$route.params.tabId" @onClick="onClickTab"></Tab>
    <div class="tabContent" v-if="$route.params.tabId == tabText[0].val">
      <div>
        <div class="tabHeader">
          <div class="button-block">
            <div class="select-block">
              <Select :options="state.opDL" @onChange="selectChange" v-model:selected="state.selectVal1"
                style="height: 42px;"></Select>

            </div>
            <Button type="full" @onClick="modalDeviceList" class="btn-inline" colors="dark1" theme="2" wd="mlg"
              icon="icon-add" :text="t('__d7d_n17r.__addDevice')"></Button>
          </div>

          <div class="button-block">

            <Button :disable="!state.list.length" type="full" @onClick="deleteDevice" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')"></Button>

          </div>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
            @goTableLink="goDeviceLink" :columns="deviceListCol" :data="state.deviceListData" tablePadding="20"
            :checkBox="true">
            <!-- <template #contextMenu="{position}">
              <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
            </template> -->
            <template #empty="{text}">
              <div class="Nodata">{{t('__g3p_m8t.__noAnyDevice')}}</div>
            </template>
          </Table>

        </div>

      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>



    <div class="tabContent" v-if="$route.params.tabId == tabText[1].val">
      <div>
        <div class="tabHeader">
          <div class="select-block">
            <Select :options="state.opET" v-model:selected="state.selectVal1" style="height: 42px;"></Select>
          </div>
          <div>
            <Button :disable="!state.list.length" type="full" @onClick="deleteET" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')"></Button>
          </div>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort" :disableCheck="state.tableDisableList" @onCheckAll="onCheckAll"
            @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach" @goTableLink="goTableLink" :columns="exeListCol"
            :data="state.exeListData" tablePadding="20" :checkBox="true" :defaultCheck="state.defaultCheckIndexList">
            <template #second="{index, data}">
              <TableInfo :data="data.dataInfo" :columns="state.appList2col">
                <!-- <template #button="{data}">  :custom="'button'"
                  <Button class="btn-inline" type="border" @onClick="applyCalibration(data)" text="Apply to Calibration"></Button>
                </template> -->
              </TableInfo>
            </template>

            <template #modeColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modeColData="{index, data, text, col}">
              <span >
                {{modeCol(data, col)}}
              </span>
            </template>
            <!-- <template #contextMenu="{position}">
              <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
            </template> -->
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyTask')}}</div>
            </template>
          </Table>

        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>



    <div class="tabContent" v-if="$route.params.tabId == tabText[2].val">
      <div>
        <div class="tabHeader">
          <div class="select-block">
            <Select :options="state.opAP" v-model:selected="state.selectVal1" style="height: 42px;"></Select>
          </div>
          <div>
            <Button :disable="!state.list.length" type="full" @onClick="deleteAP" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')"></Button>
          </div>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
            :defaultCheck="state.defaultCheckIndexList" @goTableLink="goTableLink" :dropdown="'dataInfo'"
            :columns="appListCol" :data="state.appListData" tablePadding="20" :checkBox="true">
            <template #second="{index, data}">
              <div class="dataInfo">
                <div v-for="(each , i) in data.dataInfo">
                  <TableInfo :columns="setAppListColSub(each.col)" :data="each.data">
                  </TableInfo>
                </div>
              </div>
            </template>
            <template #modifyth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modify="{index ,data}">
              <span class="editIcon" @click="editApp(data)"
              @keypress.enter="editApp(data)">
                <iCon iconClass="asus_proart_sw_ico_edit_1"></iCon>
              </span>
            </template>


            <template #repeatColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #repeatColData="{index, data, text, col}">
              <span >
                {{setRepeatCol(data)}}
              </span>
            </template>

            <!-- <template #contextMenu="{position}">
              <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
            </template> -->
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyAppointment')}}</div>
            </template>
          </Table>

        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>
    <div class="tabContent" v-if="$route.params.tabId == tabText[3].val">
      <div class="setting">
        <div class="title">{{t('__d4e_m8t.__permissionSettings')}}</div>
        <div class="warn">{{t('__d4e_m8t.__allowsFunctionsThatCanBeUsed')}}</div>
        <div class="setblock">
          <div class="set ">
            <!-- <div>{{state.settingIcon}}</div> -->
            <div class="option" v-for="e in state.settingIcon">
              <Switcher v-model:isCheck="e.status" class="switcher"></Switcher>
              <!-- <iCon @click="settingLock(e)" :class="{'gold': e.status }"
                :iconClass="e.status ? 'asus_proart_sw_ico_unlock' : 'asus_proart_sw_ico_lock'" class="settingIcon">
              </iCon> -->
              <span>{{t(e.text)}}</span>
            </div>
          </div>
          <Button id="GTM__permissionSettingsApplyGroup" @onClick="editGroupSetting" :text="t('__g3p_m8t.__applyAllDevices')" class="btn-inline" colors="main"
            theme="1"></Button>
          <!-- :disable="state.applyDisable" -->
        </div>
      </div>
    </div>




  </div>

</section>